import React from 'react';
import Modal from '../shared/Modal';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import NewTermsContent from '../Static/NewTermsContent';
import { useHistory } from 'react-router';

const TermsPopup = ({ open, toggleTerms }) => {
  const history = useHistory();
  const pathname = history.location.pathname;

  const privacyUrl = pathname.includes('sf')
    ? 'https://autzu.com/sf/privacy'
    : pathname.includes('nyc')
    ? 'https://autzu.com/nyc/privacy'
    : 'https://autzu.com/tor/privacy';

  return (
    <Modal open={open} backgroundColor="none">
      <div className="terms-popup-container">
        <div onClick={toggleTerms} className="terms-close">
          <FontAwesomeIcon icon={faTimes} size="2x" />
        </div>
        <div className="form-title" style={{ fontSize: '24px' }}>
          Terms and Conditions
        </div>
        <NewTermsContent pathname={pathname} privacyUrl={privacyUrl} />
      </div>
    </Modal>
  );
};

export default TermsPopup;



// WEBPACK FOOTER //
// ./src/components/NewSignUp/TermsPopup.js